import React, { useContext, useEffect } from "react";
import {
  Box,
  CircularProgress,
  IconButton,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";
import { useNavigate, Navigate, Route } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import ImageContext from "../../ImageContext";
import AppContext from "../../AppContext";
import { generateClient } from "aws-amplify/api";
import getImage from "./queries/getImage.js";
const client = generateClient();

export const PhotosScreenLayout = () => {
  const [globalState, setGlobalState, q, p] = useContext(AppContext);
  const [previewImage, setPreviewImage] = useContext(ImageContext);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      p.prevPage = p.currentPage || "view-photo";
      p.currentPage = "view-photo";

      if (!p.previewImage) {
        const photoID = window.location.href?.split(
          `${process.env.REACT_APP_WEBSITE}/photos/`
        )[1];
        console.log("photoID", photoID);

        const res = await client.graphql({
          query: getImage(photoID),
        });

        setPreviewImage({
          id: photoID,
          url: res.data.getImage.url,
          index: 0,
        });
      }
    })();
  }, []);

  const onClickClose = () => {
    p.imageCarousel = [];

    if (!p.prevURLPath) {
      return navigate("/");
    } else {
      navigate(p.prevURLPath);
    }
  };

  const loadNextImage = (direction) => () => {
    const nextImageObject =
      p.imageCarousel[
        direction === "next"
          ? (previewImage.index + 1) % p.imageCarousel.length
          : (previewImage.index - 1 + p.imageCarousel.length) %
            p.imageCarousel.length
      ];

    setPreviewImage(nextImageObject);
    navigate(`/photos/${nextImageObject.id}`);
  };

  // https://cdn.qa.sociogram.com/app/features/post/photos/64a36d05-a763-4749-88c9-16db4b1abdee.jpeg
  return (
    <Box>
      <Box
        sx={{
          position: "relative",
          height: "100vh",
          background: "rgba(0, 0, 0, 0.9)",
        }}
      >
        <IconButton
          onClick={onClickClose}
          size="medium"
          variant="contained"
          sx={{
            position: "absolute",
            top: 15,
            left: 15,
            zIndex: 10,
            background: "rgba(255,255,255,0.05)",
            "&:hover": {
              background: "rgba(255,255,255,0.1)",
            },
          }}
        >
          <SvgIcon sx={{ color: "white" }}>
            <CloseIcon />
          </SvgIcon>
        </IconButton>

        <Box
          component={"div"}
          sx={{
            background: `url("${previewImage?.["url"]}")`,
            backgroundSize: "contain",
            width: "100%",
            height: "100%",
            position: "absolute",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
          }}
        >
          <CircularProgress
            size={64}
            sx={{
              mr: 1,
              ml: -0.5,
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 4,

              color: "rgb(31, 109, 153)"
            }}
          />
        </Box>

        <Box
          component={"div"}
          sx={{
            zIndex: 5,
            background: `url("${previewImage?.["url"]}")`,
            backgroundSize: "contain",
            width: "100%",
            height: "100%",
            position: "absolute",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
          }}
        ></Box>

        {p.imageCarousel?.length > 1 && (
          <Box
            sx={{
              position: "absolute",
              bottom: 0,
              height: 48,
              width: "calc(100% - 32px)",
              top: "50%",
              transform: "translateY(-50%)",
              display: "flex",
              justifyContent: "space-between",
              padding: 2,
              color: "white",
              zIndex: 11,
            }}
          >
            {previewImage?.index > 0 ? (
              <IconButton
                onClick={loadNextImage("prev")}
                sx={{
                  width: 48,
                  height: 48,
                  color: "white",
                  background: "rgba(11, 7, 7, 0.05)",
                  "&:hover": {
                    background: "rgba(255,255,255,0.1)",
                  },
                }}
              >
                <KeyboardArrowLeft />
              </IconButton>
            ) : (
              <Box />
            )}

            {previewImage?.index < p.imageCarousel?.length-1 ? (
              <IconButton
                onClick={loadNextImage("next")}
                sx={{
                  width: 48,
                  height: 48,
                  color: "white",
                  background: "rgba(255,255,255,0.05)",
                  "&:hover": {
                    background: "rgba(255,255,255,0.1)",
                  },
                  zIndex: 12,
                }}
              >
                <KeyboardArrowRight />
              </IconButton>
            ) : (
              <Box />
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default {};
